export default "/images/vendor/@alquiler-argentina/aa-componentes/es/logo-bottom.svg?78a095baaeae5cd525f06404697b88b3";